import { UserOutlined } from '@ant-design/icons';
import { Alert, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;


const Description = (name, isUser, cuit) => {
    return isUser ?
        (
            <>
                <p>{name}</p>
                <p style={{ fontWeight: "bold" }}>{cuit}</p>
                <Text mark style={{ fontSize: "12px" }} >IMPORTANTE:</Text>
                <Text> El asegurado ya se encuentra registrado. El envío del siguiente formulario modificará la información existente</Text>
            </>
        )
        : name
}

const InsuredPerson = ({ name, isUser, cuit }) => {
    return (
        <Alert
            message="Asegurado"
            description={Description(name, isUser, cuit)}
            type="success"
            icon={<UserOutlined />}
            showIcon
            style={{ marginBottom: "20px " }}
        />

    );
}

export default InsuredPerson;

